import produce from 'immer';

// import { formatDate } from 'utils/genericFunctions';
import { Types, enviaSMSPositus } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: enviaSMSPositus = {
	status: 0,
	data: null,
};

export default function enviaSMSPositusReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): enviaSMSPositus {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIAR_SMS_POSITUS_REQUEST: {
				break;
			}
			case Types.ENVIAR_SMS_POSITUS_SUCCESS: {
				draft.data = action.payload.response.data;
				draft.status = action.payload.response.status;
				break;
			}
			case Types.ENVIAR_SMS_POSITUS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				break;
			}
			case Types.ENVIAR_SMS_POSITUS_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}
			default:
		}
	});
}
